import { PostSignInterface } from '../../../../interface/sign-in/post-sign.interface'
import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

export const postSignInService = ({ email, password }: PostSignInterface) =>
  apiInstance.post(ApiPathConfig.SIGN_IN, {
    email,
    password,
  })
